import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { getExpressParams, postExpress, deleteExpressParams, getExpress } from '../../../service/api';
import QueryManagerMain from '../../presentation/section/query-manager-page/QueryManagerMain';
import JSONtoChartData from '../json-to-chartdata/JSONtoChartData';

import produce from 'immer';
import ExportExcel from '../export-excel/ExportExcel';
import { REPORT_RANGE } from '../../../config/CalendarRangeSet';
// import ExportExcel from '../export-excel/ExportExcel';
import LoadingOverlay from 'react-loading-overlay';
import { queryValidator } from '../function/QueryValidator';


const toJavaScriptString = (jsonString) => {
  var result = jsonString.replace(/\\n/g, "\\n")  
                          .replace(/\\'/g, "\\'")
                          .replace(/\\"/g, '\\"')
                          .replace(/\\&/g, "\\&")
                          .replace(/\\r/g, "\\r")
                          .replace(/\\t/g, "\\t")
                          .replace(/\\b/g, "\\b")
                          .replace(/\\f/g, "\\f")
                          .replace(/\\\\/g, "\\\\");

  result = result.replace(/[\u0000-\u0019]+/g, "");
  return result;
}
const getDefaultDateRange = () => {
  const today = new Date();
  const aWeekAgoDate = new Date();
  aWeekAgoDate.setDate(today.getDate()-7);
  return [aWeekAgoDate, today];
}

const QueryManager = (props) => {
  const [selectedQuery, setSelectedQuery] = useState({
    queryID: null,
    content: null,
    created: null,
    name: null,
    QUERY_TYPE: null,
    updated: null,
    label: null,
    owner: null,
  });
  const [queryLabelData, setQueryLabelData] = useState({
    type: null,
    name: null,
    owner: null,
    info: [],
    nullLabelItem: [],
    nullLabelItemType: null,
  })
  const [resultData, setResultData] = useState({
    buzzlist: null,
    volume: null
  });
  const [andString, setAndString] = useState('');
  const [orString, setOrString] = useState('');
  const [notString, setNotString] = useState('');
  const [booleanQuery, setBooleanQuery] = useState('');
  const [editable, setEditable] = useState(false);
  const [dateRange, setDate] = useState(getDefaultDateRange());

  const [queryFilter, setQueryFilter] = useState('');
  const [filteredArray, setFilteredArray] = useState({
    type: null,
    name: null,
    owner: null,
    info: [],
    nullLabelItem: [],
    nullLabelItemType: null,
  });
  const [loaded, setLoaded] = useState(true);

  const [tempQuery, setTempQuery] = useState(null)
  const [userRole, setUserRole] = useState('');

  useEffect(()=>{
    getExpressParams('/query/query-label/userid/all', {
      email: props.currentUser
    }, (response)=>{
      setQueryLabelData(MakeLabelTreeData(response.data.queryentity, response.data.BuzzLabel))
    })

    getExpressParams('/users/role/userid', {
      email: props.currentUser
    }, (response) => {
      setUserRole(response.data[0].role)
    })
  }, []);

  useEffect(()=> {
    handleSearchBtn(JSON.stringify(queryLabelData));
  },[queryLabelData])

  const handleSearchBtn = (originArray) => {
    let tempArray = JSON.parse(originArray);
    tempArray.nullLabelItem = tempArray.nullLabelItem.filter((item)=>!queryFilter || item.name.toLowerCase().startsWith(queryFilter.toLowerCase()));

    tempArray.info.forEach(
      (item) => {
        item.labelItem = item.labelItem.filter((queryItem)=> !queryFilter || queryItem.name.toLowerCase().startsWith(queryFilter.toLowerCase()));
      }
    )
    tempArray.info = tempArray.info.filter(
      ((item)=>item.labelItem.length > 0)
    );
    
    setFilteredArray(tempArray);
    // setSelectedQuery({
    //   queryID: null,
    //   content: null,
    //   created: null,
    //   name: null,
    //   QUERY_TYPE: null,
    //   updated: null,
    //   label: null,
    //   owner: null,
    //   chceked: false
    // })
    // setAndString('')
    // setOrString('')
    // setNotString('')
    // setBooleanQuery('')
    setEditable(false);
    setResultData({
      buzzlist: null,
      volume: null
    })
  }

  const handleSearchInput = (event) => {
    setQueryFilter(event.target.value);
  }

  const handleDate = (selectedDateRange) => {
    setDate(selectedDateRange); 
  }

  const handleRefresh = () => {
    if(!tempQuery){
    }
    else{
      setLoaded(false);
      setResultData({
        buzzlist: null,
        volume: null
      })
      getExpressParams("/search/query-content", {
        "query": tempQuery.query,
        "type": tempQuery.type,
        "dateRange": [dateRange[0].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"}), dateRange[1].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})]
      },
      (res)=>{
        setLoaded(true);
  
        let resData = res.data;
        resData.volume = JSONtoChartData({data:res.data.volume, type:"report-line"})
        setResultData(resData);
  
      });
    }
  }

  const handleEditable = (bool) => {
    setEditable(bool);
  }

  const handleBooleanQuery = (event) => {
    setBooleanQuery(event.target.value);
  }

  const handleNotString = (event) => {
    setNotString(event.target.value);
  }

  const handleOrString = (event) => {
    setOrString(event.target.value);
  }

  const handleAndString = (event) => {
    setAndString(event.target.value);
  }

  const handleSaveBtn = (query, queryID, type) => {
    switch (type) {
      case "BOOLEAN": {
        if(queryValidator(query.boolQuery)){
          postExpress('/query/query-content/userid', {
            email: props.currentUser,
            query: query,
            queryID: queryID
          }, (response) => {
            setQueryLabelData(MakeLabelTreeData(response.data.queryentity, response.data.BuzzLabel));
            setSelectedQuery(response.data.query);
            setDefaultQueryText(response.data.query);
          });
          handleEditable(false);
          setResultData({
            buzzlist: null,
            volume: null
          })
        }
        else{
        }
        break;
      }
      case "BASIC": {
        postExpress('/query/query-content/userid', {
          email: props.currentUser,
          query: query,
          queryID: queryID
        }, (response) => {
          setQueryLabelData(MakeLabelTreeData(response.data.queryentity, response.data.BuzzLabel));
          setSelectedQuery(response.data.query);
          setDefaultQueryText(response.data.query);
        });
        handleEditable(false);
        setResultData({
          buzzlist: null,
          volume: null
        })
        break;
      }
      default:
        break;
    }
  }

  const handleCancelBtn = (queryInfo) => {
    setDefaultQueryText(queryInfo);
    handleEditable(false);
  }

  const handleRemoveBtn = (queryID) => {
    deleteExpressParams(`/query/query-content/queryid/`, {
      email: props.currentUser,
      queryID: queryID
    },(response)=>{
      setQueryLabelData({
        type: null,
        name: null,
        owner: null,
        info: [],
        nullLabelItem: [],
        nullLabelItemType: null,
      });
      setQueryLabelData(MakeLabelTreeData(response.data.queryentity, response.data.BuzzLabel));
      setTempQuery(null)
      setSelectedQuery({
        queryID: null,
        content: null,
        created: null,
        name: null,
        QUERY_TYPE: null,
        updated: null,
        label: null,
        owner: null,
        chceked: false
      })
      setAndString('')
      setOrString('')
      setNotString('')
      setBooleanQuery('')
    })
  }

  const handleSelectedQuery = (queryInfo) => {
    setSelectedQuery(queryInfo);
    setTempQuery(null);
    setDefaultQueryText(queryInfo);
    setEditable(false);
    setResultData({
      buzzlist: null,
      volume: null
    })
  }

  const MakeLabelTreeData = (nodeData, labelData) => {
    let retLabelTreeData = labelData;
    retLabelTreeData.nullLabelItemType = nodeData.type;
    retLabelTreeData.nullLabelItem = [];
    retLabelTreeData.info.forEach((item,index)=> {
      item.labelItem = [];
      item.checked = false;
      nodeData.info.filter((filteredNode)=>filteredNode.label==item.labelID).forEach(
        (filteredItem, index) => {
          let pushItem = filteredItem;
          pushItem.checked = false;
          item.labelItem.push(pushItem);
          item.labelItemType = nodeData.type;
      })
    })
    nodeData.info.filter((filteredNode) => filteredNode.label==null).forEach(
      (item)=>{
        let pushItem = item;
        pushItem.checked = false;
        retLabelTreeData.nullLabelItem.push(pushItem);
      }
    );
    return retLabelTreeData;
  }

  const checkQueryResult = (path, query, result) => {

    switch (query.type) {
      case "BOOLEAN":{
          if (queryValidator(query.query.boolQuery)){
            setLoaded(false);
            setTempQuery(query);
            setResultData({
              buzzlist: null,
              volume: null
            })
            getExpressParams(path, query,
            (res)=>{
              setLoaded(true);
        
              let resData = res.data;
              resData.volume = JSONtoChartData({data:res.data.volume, type:"report-line"})
              setResultData(resData);        
            });
          }
          else {
          }
          break;
        }
      case "BASIC":{
          setLoaded(false);
          setTempQuery(query);
          setResultData({
            buzzlist: null,
            volume: null
          })
          getExpressParams(path, query,
          (res)=>{
            setLoaded(true);
      
            let resData = res.data;
            resData.volume = JSONtoChartData({data:res.data.volume, type:"report-line"})
            setResultData(resData);
      
          });
          break;
        }
      default:
        break;
    }
  }

  const setDefaultQueryText = (props) => {
    switch (props.QUERY_TYPE) {
      case "BASIC": {
        setAndString(JSON.parse(toJavaScriptString(props.content)).and.join(', '))
        setOrString(JSON.parse(toJavaScriptString(props.content)).or.join(', '))
        setNotString(JSON.parse(toJavaScriptString(props.content)).not.join(', '))
        break;
      }
      case "BOOLEAN":{
        // let modQuery = props.content.replace(/(\r|\n|\t)/gm,"");
        // modQuery = modQuery.replace('": "','":"');
        setBooleanQuery(JSON.parse(toJavaScriptString(props.content)).boolQuery);
        break;
      }
      default:
        break;
    }
  }

  // const handleCheckedArray = (value, type, id) => {
  //   console.log(value)
  //   console.log(type)
  //   console.log(id)
  //   if (value) {
  //     let obj = {};
  //     obj[type] = id;
  //     setCheckedList([...checkedList, obj])
  //   }
  //   else {
  //     setCheckedList(checkedList.filter(item=>item[type]!=id));
  //   }
  // }

  const handleCheckBox = (type, id, value) => {
    switch (type) {
      case "label" :{
        setQueryLabelData( 
          produce(queryLabelData, (draft) => {
            const label = draft.info.find((label) => label.labelID == id);
            label.checked = value;
          })
        );
        setTempQuery(null);
        setSelectedQuery({
          queryID: null,
          content: null,
          created: null,
          name: null,
          QUERY_TYPE: null,
          updated: null,
          label: null,
          owner: null,
          chceked: false
        })
        setAndString('')
        setOrString('')
        setNotString('')
        setBooleanQuery('')
        break;
      }
      case "query" :{
        setQueryLabelData(
          produce(queryLabelData, (draft) => {
            const query = draft.nullLabelItem.find((query) => query.queryID == id);
            query.checked = value;
          })
        )
        setTempQuery(null);
        setSelectedQuery({
          queryID: null,
          content: null,
          created: null,
          name: null,
          QUERY_TYPE: null,
          updated: null,
          label: null,
          owner: null,
          chceked: false
        })
        setAndString('')
        setOrString('')
        setNotString('')
        setBooleanQuery('')
        break;
      }
      default:
        break;
    }
  }

  const handleAllSelectBtn = () => {
    setQueryLabelData(
      produce(queryLabelData, (draft) => {
        const label = draft.info;
        label.forEach(item=>item.checked=true);
        const query = draft.nullLabelItem;
        query.forEach(item=>item.checked=true);
      })
    )
    setTempQuery(null);
    setSelectedQuery({
      queryID: null,
      content: null,
      created: null,
      name: null,
      QUERY_TYPE: null,
      updated: null,
      label: null,
      owner: null,
      chceked: false
    })
    setAndString('')
    setOrString('')
    setNotString('')
    setBooleanQuery('')
  }

  const handleAllDeselectBtn = () => {
    setQueryLabelData(
      produce(queryLabelData, (draft) => {
        const label = draft.info;
        label.forEach(item=>item.checked=false);
        const query = draft.nullLabelItem;
        query.forEach(item=>item.checked=false);
      })
    )
    setTempQuery(null);
    setSelectedQuery({
      queryID: null,
      content: null,
      created: null,
      name: null,
      QUERY_TYPE: null,
      updated: null,
      label: null,
      owner: null,
      chceked: false
    })
    setAndString('')
    setOrString('')
    setNotString('')
    setBooleanQuery('')
  }

  const handleExportBtn = () => {
    return ExportExcel("query-label",queryLabelData, userRole);
  }

  return (
    <LoadingOverlay
      active={!loaded}
      spinner={true}
      text="Now Loading...">
      <QueryManagerMain handleSelectedQuery={handleSelectedQuery} queryLabelData={queryLabelData}
        selectedQuery={selectedQuery} andString={andString} orString={orString} notString={notString} booleanQuery={booleanQuery}
        handleAndString={handleAndString} handleOrString={handleOrString} handleNotString={handleNotString} handleBooleanQuery={handleBooleanQuery}
        editable={editable} handleEditable={handleEditable} handleCancelBtn={handleCancelBtn} handleSaveBtn={handleSaveBtn}
        checkQueryResult={checkQueryResult} resultData={resultData} dateRange={dateRange} handleRemoveBtn={handleRemoveBtn}
        handleDate={handleDate} handleCheckBox={handleCheckBox} handleAllSelectBtn={handleAllSelectBtn} handleAllDeselectBtn={handleAllDeselectBtn}
        handleExportBtn={handleExportBtn} handleSearchBtn={handleSearchBtn} queryFilter={queryFilter} handleSearchInput={handleSearchInput} filteredArray={filteredArray}
        minDate={REPORT_RANGE(props.currentRole)} handleRefresh={handleRefresh}
      />
    </LoadingOverlay>
  )
}

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser,
  currentRole: state.AuthManager.status.currentRole
});
export default connect(mapStateToProps) (QueryManager);